import MainLayout from 'Layouts/Main/Main';
import { lazy } from 'react';

const Teleconsult = lazy(() => import('Containers/Teleconsult/Teleconsult'));

const routes = [
  {
    path: '/web-chat',
    exact: true,
    ContentComponent: Teleconsult,
    Layout: MainLayout,
    bodyClass: 'page-chat',
    name: 'Teleconsult',
  },
  {
    path: '/web-chat/:id',
    exact: true,
    ContentComponent: Teleconsult,
    Layout: MainLayout,
    bodyClass: 'page-chat',
    name: 'Teleconsult',
  },
];

export default routes;
